app.controller('popupPatientStatementController', ['$scope', '$state', '$mdDialog', 'objectHelper', 'baseModel', 'applicationModel', 'dictionaryModel', 'userModel', 'doctorModel', 'clinicModel', 'patientModel', 'statementModel', 'patient', 'statement', 'statementPopup',
    function ($scope, $state, $mdDialog, objectHelper, baseModel, applicationModel, dictionaryModel, userModel, doctorModel, clinicModel, patientModel, statementModel, patient, statement, statementPopup) {

        function setData() {
            $scope.clinic = null;
            $scope.patient = patient;
            $scope.presentDate = new Date();

            if(statement) {
                $scope.statement = statement;
            } else {
                $scope.statement = new StatementVO();
                $scope.statement.patient = $scope.patient;
                $scope.statement.stateOfHealthDataAccess = false;
                $scope.statement.medicalDataAccess = false;
            }

            $scope.parentDialog = statementPopup;
            $scope.editStatementMode = ($scope.statement.id) ? true : false;


            $scope.forms = {
                patientDeclaration: null
            }
        }

        function setPermissions() {
        }

        function setListeners() {

            $scope.$on(Event.DICTIONARY.GET_DICTIONARY_ELEMENT_DATA_PAGE.SUCCESS, function (event, dataPage, code) {
                if(code === Constant.DICTIONARY_CODE.CITIZENSHIP) {
                    $scope.citizenshipList = dataPage.data;
                }
                if(code === Constant.DICTIONARY_CODE.STATE) {
                    $scope.stateList = dataPage.data;
                }
            });

            $scope.$on(Event.DOCTOR.GET_BY_ID.SUCCESS, function(event, doctor) {
            });

            $scope.$on(Event.CLINIC.GET_BY_ID.SUCCESS, function(event, clinic) {
                $scope.clinic = clinic;
            });

            $scope.$on(Event.PATIENT.UPDATE.SUCCESS, function(event, patient) {
                $scope.patient = patient;
            })

        }

        function setActions() {
            $scope.save = function() {
                if(($scope.statement.stateOfHealthDataAccess && !$scope.statement.authorizedPerson) || ($scope.statement.medicalDataAccess && !$scope.statement.authorizedPerson)) {
                    return false;
                }
                $scope.forms.patientDeclaration.$setSubmitted();
                if($scope.forms.patientDeclaration.$valid) {

                    if($scope.statement.id) {
                        statementModel.update($scope.statement);

                        var successWatcherDisabler = $scope.$on(Event.STATEMENT.UPDATE.SUCCESS, function (event, result) {
                            successWatcherDisabler();
                            errorWatcherDisabler();
                            $mdDialog.hide();
                        });
                        var errorWatcherDisabler = $scope.$on(Event.STATEMENT.UPDATE.SUCCESS, function (event, error) {
                            successWatcherDisabler();
                            errorWatcherDisabler();
                        });
                    } else {
                        statementModel.save($scope.statement);

                        var successSaveWatcherDisabler = $scope.$on(Event.STATEMENT.SAVE.SUCCESS, function (event, result) {
                            successSaveWatcherDisabler();
                            errorSaveWatcherDisabler();
                            $mdDialog.hide();
                        });
                        var errorSaveWatcherDisabler = $scope.$on(Event.STATEMENT.SAVE.SUCCESS, function (event, error) {
                            successSaveWatcherDisabler();
                            errorSaveWatcherDisabler();
                        });
                    }

                }
            };

            $scope.cancel = function() {
                $mdDialog.cancel();
            };

            $scope.addNewAuthorizedPerson = function() {
                $mdDialog.show({
                    templateUrl: 'edm/application/view/app/patient/popup/popup-authorized-person.html',
                    controller: 'popupAuthorizedPersonController',
                    resolve: {
                        authorizedPersonData: function() {
                            return null;
                        }
                    }
                }).then(function(authPerson) {
                    $scope.patient.authorizedPersons.push(authPerson);
                    patientModel.update($scope.patient);
                    $scope.parentDialog();
                }, function() {

                });
            };

            }

        function configureInterface() {

        }

        function initialize() {
            clinicModel.getById(userModel.currentUser.clinicId);
        }

        setData();
        setPermissions();
        setListeners();
        setActions();
        configureInterface();
        initialize();
    }
]);